module.exports = __webpack_public_path__ + "public/images/flags/Flag_of_Belarus.57b43b0efdfa6509dd535884884f7338.png";